/*
 * CUSTOM DASH COMPONENT TO ALLOW US TO EASILY DEFINE css STYLES WITHIN A COMPONENT
 */
import React from 'react';

export default (props) => {
	return (
		<style dangerouslySetInnerHTML={{__html: props.styles}} />
	)
}